<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  page: {
    title: "Pegawai Eksternal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Datatable, Pagination },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "NIP",
        name: "u_nip",
      },
      {
        width: "auto",
        label: "Nama",
        name: "nama",
      },
      {
        width: "auto",
        label: "Unit",
        name: "u_namaunit1",
      },
      {
        width: "auto",
        label: "Jabatan",
        name: "jabatan",
      },
      {
        width: "150px",
        label: "Aksi",
        name: "-",
      },
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Pegawai Eksternal",
      items: [
        // {
        //   text: "Master",
        //   href: "/",
        // },
        // {
        //   text: "Pegawai Eksternal",
        //   active: true,
        // },
      ],
      isWrite: localStorage.getItem("isWrite"),
      loadingTable: true,
      tableData: [],
      columns: columns,
      sortKey: "u_nip",
      sortOrders: sortOrders,
      tableFilter: {
        page: 1,
        per_page: 10,
        nip: "",
        nama: "",
        unit: "",
        jabatan: "",
        active_flag: 1,
        column: "u_nip",
        dir: "asc",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      formPayload: {},
      modalTambah: false,
      modalEdit: false,
    };
  },
  mounted() {
    if (this.isWrite != 1) this.columns.pop();
    this.filterData = _.debounce(this.getTableData.bind(this), 500);
    this.getTableData();
  },
  methods: {
    async getTableData(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.loadingTable = true;
      const data = await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/pegawai-eksternal",
        params: this.tableFilter,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err get data:", err);
          return false;
        });
      if (data) {
        this.tableData = data.data.data;
        this.pagination.total = data.data.total;
        this.pagination.from = data.data.from;
        this.pagination.to = data.data.to;
        this.pagination.links = data.data.links;
        this.pagination.lastPageUrl = data.last_page_url;
        this.pagination.nextPageUrl = data.next_page_url;
        this.pagination.prevPageUrl = data.prev_page_url;
        this.pagination.per_page = this.tableFilter.per_page;
        this.pagination.page = this.tableFilter.page;
      }
      this.loadingTable = false;
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableFilter.page = link.get("page");
      this.getTableData(false);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getTableData();
    },
    create() {
      this.formPayload = {
        u_nip: "",
        nama: "",
        u_namaunit1: "",
        jabatan: "",
      };
      this.modalTambah = true;
    },
    async store() {
      let payload = { ...this.formPayload };
      const data = await axios({
        method: "post",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/pegawai-eksternal",
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err save data:", err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response.data.data,
          });
          return false;
        });
      if (data) {
        Swal.fire({
          icon: "success",
          title: "Data berhasil disimpan",
        });
        this.getTableData();
        this.modalTambah = false;
      }
    },
    edit(row) {
      this.formPayload = { ...row };
      this.modalEdit = true;
    },
    async update() {
      let payload = { ...this.formPayload };
      const data = await axios({
        method: "put",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/pegawai-eksternal/" +
          payload?.idpegawai_eksternal, // Assuming 'idpegawai_eksternal' is the primary key
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err save data:", err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response.data.data,
          });
          return false;
        });
      if (data) {
        Swal.fire({
          icon: "success",
          title: "Data berhasil diperbarui",
        });
        this.getTableData();
        this.modalEdit = false;
      }
    },
    changeStatus(id, newStatus) {
      const actionText = newStatus === 0 ? "menonaktifkan" : "mengaktifkan";
      Swal.fire({
        icon: "warning",
        title: `Apakah Anda yakin untuk ${actionText} data ini ?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Ya`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "put",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/pegawai-eksternal/" + id + "/status",
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          })
            .then((response) => response.data)
            .catch((err) => {
              console.log("err change status:", err);
              Swal.fire({
                icon: "error",
                text: "Terjadi Kesalahan",
                title: "Silahkan coba kembali beberapa saat lagi",
              });
              return false;
            });
          if (data) {
            Swal.fire({
              icon: "success",
              title: `Data Berhasil di${actionText}`,
            });
            this.getTableData();
          }
        }
      });
    },
    destroy(id) {
      Swal.fire({
        icon: "warning",
        title: "Apakah Anda yakin menghapus data ini secara permanen?",
        text: "Data yang dihapus tidak dapat dipulihkan kembali.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Ya`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "delete",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/pegawai-eksternal/" + id,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          })
            .then((response) => response.data)
            .catch((err) => {
              console.log("err delete data:", err);
              Swal.fire({
                icon: "error",
                text: "Terjadi Kesalahan",
                title: "Silahkan coba kembali beberapa saat lagi",
              });
              return false;
            });
          if (data) {
            Swal.fire({
              icon: "success",
              title: "Data Berhasil dihapus",
            });
            this.getTableData();
          }
        }
      });
    },
    exportExcel() {
      const params = new URLSearchParams(this.tableFilter).toString();
      window.open(
        `${process.env.VUE_APP_BACKEND_URL_VERSION}export-excel/pegawai-eksternal?${params}`,
        "_blank"
      );
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="d-flex gap-2 justify-content-end">
                  <button
                    type="button"
                    class="btn btn-success btn-sm"
                    @click="exportExcel"
                  >
                    <i class="mdi mdi-file-excel me-1"></i> Export Excel
                  </button>
                  <button
                    class="btn btn-primary btn-sm"
                    @click="create()"
                    v-if="isWrite == 1"
                  >
                    <i class="fa fa-plus me-1"></i> Tambah
                  </button>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="form-group col-md">
                <label for="filterNIP">NIP</label>
                <input
                  type="text"
                  id="filterNIP"
                  class="form-control"
                  placeholder="Filter NIP"
                  v-model="tableFilter.nip"
                  @input="filterData"
                />
              </div>
              <div class="form-group col-md">
                <label for="filterNama">Nama</label>
                <input
                  type="text"
                  id="filterNama"
                  class="form-control"
                  placeholder="Filter Nama"
                  v-model="tableFilter.nama"
                  @input="filterData"
                />
              </div>
              <div class="form-group col-md">
                <label for="filterUnit">Unit</label>
                <input
                  type="text"
                  id="filterUnit"
                  class="form-control"
                  placeholder="Filter Unit"
                  v-model="tableFilter.unit"
                  @input="filterData"
                />
              </div>
              <div class="form-group col-md">
                <label for="filterJabatan">Jabatan</label>
                <input
                  type="text"
                  id="filterJabatan"
                  class="form-control"
                  placeholder="Filter Jabatan"
                  v-model="tableFilter.jabatan"
                  @input="filterData"
                />
              </div>
              <div class="form-group col-md">
                <label for="filterStatus">Status</label>
                <select
                  id="filterStatus"
                  class="form-control"
                  v-model="tableFilter.active_flag"
                  @change="getTableData(true)"
                >
                  <option value="1">Aktif</option>
                  <option value="0">Tidak Aktif</option>
                </select>
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getTableData()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="loadingTable">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i>
                      Loading
                    </td>
                  </tr>
                  <tr v-else-if="tableData.length < 1">
                    <td colspan="99" class="text-center">Data Empty</td>
                  </tr>
                  <tr v-else v-for="(row, index) in tableData" :key="index">
                    <td>{{ index + pagination.from }}</td>
                    <td>{{ row.u_nip }}</td>
                    <td>{{ row.nama }}</td>
                    <td>{{ row.u_namaunit1 }}</td>
                    <td>{{ row.jabatan }}</td>
                    <td v-if="isWrite == 1">
                      <div class="btn-group">
                        <button
                          class="btn btn-warning btn-sm"
                          @click="edit(row)"
                          v-if="tableFilter.active_flag == 1"
                        >
                          <i class="fa fa-edit me-1"></i>
                          Edit
                        </button>
                        <button
                          v-if="tableFilter.active_flag == 1"
                          class="btn btn-danger btn-sm"
                          @click="changeStatus(row.idpegawai_eksternal, 0)" 
                        >
                          <i class="fa fa-trash me-1"></i> Disable
                        </button>
                        <button
                          v-if="tableFilter.active_flag == 0"
                          class="btn btn-success btn-sm"
                          @click="changeStatus(row.idpegawai_eksternal, 1)" 
                        >
                          <i class="fa fa-recycle me-1"></i> Enable
                        </button>
                        <button
                          v-if="tableFilter.active_flag == 0"
                          class="btn btn-danger btn-sm"
                          @click="destroy(row.idpegawai_eksternal)" 
                        >
                          <i class="fa fa-trash me-1"></i> Hapus
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
              <Pagination
                :pagination="pagination"
                @to-page="toPage"
              ></Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="modalTambah" hide-footer title="Tambah Pegawai Eksternal">
      <form @submit.prevent="store" class="needs-validation" novalidate>
        <div class="mb-3">
          <label>NIP</label>
          <input type="text" class="form-control" v-model="formPayload.u_nip" placeholder="Masukkan NIP" />
        </div>
        <div class="mb-3">
          <label>Nama</label>
          <input type="text" class="form-control" v-model="formPayload.nama" placeholder="Masukkan Nama" />
        </div>
        <div class="mb-3">
          <label>Unit</label>
          <input type="text" class="form-control" v-model="formPayload.u_namaunit1" placeholder="Masukkan Unit" />
        </div>
        <div class="mb-3">
          <label>Jabatan</label>
          <input type="text" class="form-control" v-model="formPayload.jabatan" placeholder="Masukkan Jabatan" />
        </div>
        <div class="mb-3 text-end">
          <button type="submit" class="btn btn-primary btn-sm">
            <i class="fa fa-save"></i> Simpan
          </button>
        </div>
      </form>
    </b-modal>

    <b-modal v-model="modalEdit" hide-footer title="Edit Pegawai Eksternal">
      <form @submit.prevent="update" class="needs-validation" novalidate>
        <div class="mb-3">
          <label>NIP</label>
          <input type="text" class="form-control" v-model="formPayload.u_nip" placeholder="Masukkan NIP" />
        </div>
        <div class="mb-3">
          <label>Nama</label>
          <input type="text" class="form-control" v-model="formPayload.nama" placeholder="Masukkan Nama" />
        </div>
        <div class="mb-3">
          <label>Unit</label>
          <input type="text" class="form-control" v-model="formPayload.u_namaunit1" placeholder="Masukkan Unit" />
        </div>
        <div class="mb-3">
          <label>Jabatan</label>
          <input type="text" class="form-control" v-model="formPayload.jabatan" placeholder="Masukkan Jabatan" />
        </div>
        <div class="mb-3 text-end">
          <button type="submit" class="btn btn-primary btn-sm">
            <i class="fa fa-save"></i> Simpan
          </button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
